import { AppRoute } from '@app/core/routing/AppRoute';
import { Switch, useRouteMatch } from 'react-router-dom';
import { CreateUserPage } from './create/CreateUserPage';
import { EditUserPage } from './edit/EditUserPage';
import { ListUsersPage } from './list/ListUsersPage';
import { AdminUsersViewPage } from './view/AdminUsersViewPage';

export function AdminUsersRoutes() {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <AppRoute path={`${path}/add`} component={CreateUserPage} />
      <AppRoute path={`${path}/:id/edit`} component={EditUserPage} />
      <AppRoute path={`${path}/:id`} component={AdminUsersViewPage} />
      <AppRoute path={path} component={ListUsersPage} />
    </Switch>
  );
}
